import { Component, Input } from '@angular/core';
import {NgIf} from "@angular/common";
import {MatToolbar} from "@angular/material/toolbar";
import {MatIcon} from "@angular/material/icon";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MdcRippleDirective} from "@shared/components/top-bar-app/mdc.icon-button.directive";
import {MatIconButton} from "@angular/material/button";

@Component({
    selector: 'cf2-alt-expansion-panel',
    templateUrl: './alt-expansion-panel.component.html',
    styleUrls: ['./alt-expansion-panel.component.scss'],
  imports: [
    MatToolbar,
    MatIcon,
    ReactiveFormsModule,
    FormsModule,
    MdcRippleDirective,
    MatIconButton,
  ],
})
export class AltExpansionPanelComponent {
  @Input() isExpanded: string | boolean = true;
  @Input() displayHeader = true;
  @Input() disableExpansion = false;
  @Input() titleText = '';
  @Input() subTitleText: string;
  @Input() centreText: string;
  @Input() isCollapsable: string | boolean = true;
  displayTitleText(): boolean {
    if (this.titleText !== undefined && this.titleText.length > 0) return true;
    return false;
  }

  toggle() {
    if (this.isCollapsable) this.isExpanded = !this.isExpanded;
  }
}
